// extracted by mini-css-extract-plugin
export default {"ElementPaginationList":"PaginationTopic_ElementPaginationList__sKCE1","ItemList":"PaginationTopic_ItemList__6DCgT","PaginationPageList":"PaginationTopic_PaginationPageList__YGTXf"};